import React from 'react'
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import vforce from '../../assets/images/WhatsApp-Image-2020-10-16-at-14.25.50.jpeg';
import vforce_1 from '../../assets/images/IMG_3948-min.jpeg';
import ProjectTab from '../../components/projects_tab/ProjectTab';

const ProspectiveProjects = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
          setVisible(true);
        }, 500);
        return () => clearTimeout(timer); 
    }, []); 

  return (
    <div className="background-color">  

     <div className="max-w-4xl mx-auto ">   

    <div 
    className="position-relative overflow-hidden w-100" 
    style={{ height: '70vh', maxHeight: '600px' }}
  >
    {/* Background image with overlay */}
    <div 
      className="position-absolute top-0 start-0 w-100 h-100"
      style={{
        backgroundImage: 'url("../static/media/Footer-image-1-1-1.2c84c13e0d2ac9082e74.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: 1
      }}
    >
      <div className="w-100 h-100 bg-black" style={{ opacity: 0.5 }}></div>
    </div>
  
    {/* Centered content */}
    <div 
      className="position-absolute top-50 start-50 translate-middle text-center w-100 px-3"
      style={{
        maxWidth: '960px',
        zIndex: 2,
        transition: 'opacity 1s ease, transform 1s ease',
        transform: visible ? 'translate(-50%, -50%)' : 'translate(-50%, -40%)',
        opacity: visible ? 1 : 0
      }}
    >
      <h1 className="fw-bold text-white mb-4 display-5" style={{textTransform:'uppercase', fontFamily: 'Yanone Kaffeesatz,sans-serif'}}>Prospective Projects</h1>
      <p style={{color: 'white'}}>Gammadda has become one of the largest humanitarian initiatives in Sri Lanka and has become a case study for community driven rural development, volunteerism, community services, disaster mitigation, preparedness and relief, education services and promotion of arts and culture. </p>
    </div>
  </div>
      
    </div>

    <ProjectTab catogory ={13}/>
    

    
</div>
  )
}

export default ProspectiveProjects